// extracted by mini-css-extract-plugin
export default {"main":"ImgByContent_main__+EUxn","imgCol":"ImgByContent_imgCol__BxL2M","contentCol":"ImgByContent_contentCol__L0AKi"};